module.exports = __webpack_public_path__ + "media/theme/banner__top--back-9da229dd.png";